import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import graphql from 'babel-plugin-relay/macro'

import { useEffect, useRef, useState} from 'react'
import {useFragment} from 'react-relay'
import {twMerge} from 'tailwind-merge'


import {cn} from '../../ui/cn'
import {Tooltip} from '../../ui/Tooltip/Tooltip'
import {TooltipContent} from '../../ui/Tooltip/TooltipContent'
import {TooltipTrigger} from '../../ui/Tooltip/TooltipTrigger'
import {upperFirst} from '../../utils/upperFirst'
import {ActivityLibraryCardDescription} from './ActivityLibraryCardDescription'
import {backgroundImgMap} from './backgroundImgMap'
import { MEETING_TYPE_TO_CATEGORY} from './Categories'













export const ActivityCardImage = (props) => {
  const {className, src, category} = props
  const backgroundSrc = backgroundImgMap[category]

  return (
    _jsxs('div', {
      className: twMerge(
        'relative flex h-full w-full items-center justify-center overflow-hidden',
        className
      ),
 children: [
      _jsx('img', { className: "object-contain", src: backgroundSrc, alt: "",} )
      , _jsx('img', {
        className: "absolute top-0 left-0 h-full w-full object-contain p-10"      ,
        src: src,
        alt: "Card Illustration" ,}
      )
    ]})
  )
}










export const ActivityCard = (props) => {
  const {className, theme, title, children, type, templateRef} = props
  const category = type && MEETING_TYPE_TO_CATEGORY[type]
  const [showTooltip, setShowTooltip] = useState(false)
  const hoverTimeout = useRef(null)

  const template = useFragment(
    graphql`
      fragment ActivityCard_template on MeetingTemplate {
        ...ActivityLibraryCardDescription_template
      }
    `,
    _nullishCoalesce(templateRef, () => ( null))
  )

  const handleMouseEnter = () => {
    hoverTimeout.current = setTimeout(() => {
      setShowTooltip(true)
    }, 500)
  }

  const handleMouseLeave = () => {
    if (hoverTimeout.current) {
      clearTimeout(hoverTimeout.current)
    }
    setShowTooltip(false)
  }

  useEffect(() => {
    return () => {
      if (hoverTimeout.current) {
        clearTimeout(hoverTimeout.current)
      }
    }
  }, [])

  return (
    _jsxs('div', {
      className: "flex w-full flex-col rounded-xl p-2"    ,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
 children: [
      _jsxs('div', {
        className: twMerge(
          'relative flex h-full min-w-0 flex-col overflow-hidden rounded-lg',
          theme.secondary,
          className
        ),
 children: [
        _jsx('div', { className: "flex-1", children: children})
        , template && (
          _jsxs(Tooltip, { open: showTooltip, children: [
            _jsx(TooltipTrigger, { asChild: true, children: 
              _jsx('div', { className: "h-50 w-50 text-sky-500 hover:text-sky-700"   ,} )
            })
            , _jsxs(TooltipContent, {
              side: "bottom",
              align: "center",
              sideOffset: 20,
              className: "max-w-md whitespace-normal rounded-lg bg-white p-4 text-left text-slate-700 shadow-lg hover:cursor-pointer sm:max-w-sm"         ,
 children: [
              _jsx('div', { className: "mb-2 text-left font-semibold text-lg"   , children: title})
              , _jsx(ActivityLibraryCardDescription, { templateRef: template,} )
            ]})
          ]})
        )
      ]})
      , title && category && (
        _jsxs('div', { className: "mt-2 px-2 pb-2"  , children: [
          _jsx('div', { className: "truncate pb-1 text-lg text-slate-800 leading-5"    , children: title})
          , _jsx('div', { className: cn('font-semibold italic', `${theme.text}`), children: upperFirst(category)})
        ]})
      )
    ]})
  )
}
